const baseURL = 'https://cefr-service-dev-yfhgn4t6ea-ew.a.run.app'
export const endpoints = {
  scoreText: baseURL + '/cefr/score_text',
  scoreTextGrammar: baseURL + '/cefr/score_text_grammar',
  insertWord: baseURL + '/words',
  updateSentence: baseURL + '/cefr/cefr_levels'
}
